import { render, staticRenderFns } from "./selectBox.vue?vue&type=template&id=a0b54f6a&scoped=true&"
var script = {}
import style0 from "./selectBox.vue?vue&type=style&index=0&id=a0b54f6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b54f6a",
  null
  
)

export default component.exports